import React from 'react';
import { ExportButton } from '@common/components';
import { gql, useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import Filters from 'works/legacy/lib/filters';
import { WorkerFilterInput } from '@common/graphql';

const GENERATE_CSV_EXPORT = gql`
  mutation createWorkerExport($input: CreateWorkerExportInput!) {
    createWorkerExport(input: $input) {
      exportFile {
        id
        filename
        downloadUrl
      }
    }
  }
`;

type OnDemandTeamExportResponseType = {
  createWorkerExport: {
    exportFile: {
      id: string;
      filename: string;
      downloadUrl: string;
    };
  };
};

type Props = {
  loading?: boolean;
  disabled?: boolean;
  filters?: WorkerFilterInput;
};

export function ExportOnDemandButton({
  loading = false,
  disabled = false,
  filters,
}: Props) {
  const LOCALSTORAGE_FILTER_KEY = 'OnDemandWorkerTable';
  const onCompleted = ({
    createWorkerExport: { exportFile },
  }: OnDemandTeamExportResponseType) => {
    window.location.href = exportFile.downloadUrl;
    createMessage('success', 'CSV Export generated successfully.');
  };

  const [performExport] = useMutation(GENERATE_CSV_EXPORT, {
    onCompleted: onCompleted,
    onError: () => {
      createMessage('error', 'CSV Export failed. Please try again.');
    },
  });

  const onClick = () => {
    performExport({
      variables: {
        input: {
          filters: filters || Filters.getFilters(LOCALSTORAGE_FILTER_KEY),
        },
      },
    });
  };

  return (
    <ExportButton disabled={disabled} loading={loading} onClick={onClick}>
      Export
    </ExportButton>
  );
}
